import { colorWhite } from '@immosky/styles';
import { RealEstateObject } from '@immosky/types';
import { MapIconFactory } from './map-icon-factory';

export interface MarkerConfig {
  position: google.maps.LatLngLiteral;
  count: number;
  object?: RealEstateObject;
}

export class MapMarkerFactory {
  private iconFactory!: MapIconFactory;

  constructor(iconFactory: MapIconFactory) {
    this.iconFactory = iconFactory;
  }

  create(markerConfig: MarkerConfig): google.maps.Marker {
    const marker = new google.maps.Marker({
      position: markerConfig.position,
      icon: this.iconFactory.createIconForCount(markerConfig.count),
      label: this.createLabel(markerConfig.count.toString()),
    });

    marker.set('object', markerConfig.object);

    return marker;
  }

  private createLabel(text: string): google.maps.MarkerLabel {
    return {
      text: text,
      color: colorWhite,
      fontSize: '14px',
    };
  }
}
